import { useMemo, useState } from 'react';
import { DASHBOARD_MOBILE_MEDIA_QUERY } from 'constant';

import { Flex, useMediaQuery, useTheme, VStack } from '@chakra-ui/react';

import { LocationInterface } from 'types';

import { SelectField, Text } from 'ui';
import { LocationBlock } from '../LocationBlock';

interface LocationDropdownProps {
  locations: [string, LocationInterface[]][];
  groupedStates: { [key: string]: string };
  onSelectLocation: (item: LocationInterface) => void;
  onFavoriteIconClick: (isSelected: boolean, locationId: number) => void;
  favoriteLocationIds?: number[];
  isLogged: boolean;
}

const LocationDropdown = ({
  locations = [],
  groupedStates,
  onSelectLocation,
  onFavoriteIconClick,
  favoriteLocationIds,
  isLogged
}: LocationDropdownProps) => {
  const [currentState, setCurrentState] = useState<string>('');
  const {
    colors: {
      palette: {
        components: {
          locations: { dropdown: styles }
        }
      }
    }
  } = useTheme();
  const [isMobile] = useMediaQuery(DASHBOARD_MOBILE_MEDIA_QUERY, {
    fallback: false
  });

  const options = useMemo(
    () =>
      (locations ?? [])
        .map(([state]) => ({
          value: state,
          label: groupedStates[state]
        }))
        .filter((item) => item.value && item.label),
    [locations, groupedStates]
  );

  const handleSelectVariant = (_: string, variantValue: string) =>
    setCurrentState(variantValue);

  const filteredLocation = useMemo(
    () =>
      (locations ?? [])
        .filter(([state]) => state === currentState)
        .map((loc) => loc[1]),
    [locations, currentState]
  );

  return (
    <VStack gap='35px' w='full'>
      <Flex
        mt={{ base: '-5px', md: '-15px' }}
        px={{ base: '15px', md: '35px' }}
        py={{ base: '15px', md: '25px' }}
        bg={styles.bgColor}
        alignItems='center'
        borderRadius='12px'
        w='full'
        h={{ base: 'auto', md: '110px' }}
        gap={{ base: '15px', md: '35px' }}
        flexDirection={{ base: 'column', md: 'row' }}
      >
        <Text
          whiteSpace='nowrap'
          fontSize={['20px', '23px', '25px']}
          fontWeight='semibold'
          color={styles.textColor}
        >
          Locations by State
        </Text>
        <SelectField
          name='preferedTime'
          setFieldValue={handleSelectVariant}
          validateField={() => {}}
          setFieldTouched={() => {}}
          value={currentState}
          options={options}
          label=''
          placeholder=''
          error=''
          touched
          stylesControl={{
            paddingLeft: '20px',
            fontSize: isMobile ? '20px' : '40px',
            height: '60px',
            background: styles.controlBg,
            color: styles.controlColor,
            borderRadius: 0
          }}
          stylesOption={{
            fontSize: '20px',
            padding: '8.5px 20px 8px'
          }}
          dropdownIndicatorStyles={{
            svg: { fill: styles.indicatorColor },
            marginRight: '15px'
          }}
          stylesPlaceholder={{ margin: 0 }}
          stylesValueContainer={{
            padding: 0,
            margin: 0
          }}
        />
      </Flex>
      {filteredLocation.length && (
        <LocationBlock
          locations={filteredLocation[0]}
          state=''
          isHidedHeader
          onSelectLocation={onSelectLocation}
          onFavoriteIconClick={onFavoriteIconClick}
          favoriteLocationIds={favoriteLocationIds}
          isLogged={isLogged}
        />
      )}
    </VStack>
  );
};

export default LocationDropdown;
